/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_collection_items_empty_folder_message33 = /** @type {(inputs: {}) => string} */ () => {
	return `This folder is empty.`
};

const fr_collection_items_empty_folder_message33 = /** @type {(inputs: {}) => string} */ () => {
	return `Ce dossier est vide.`
};

const de_collection_items_empty_folder_message33 = /** @type {(inputs: {}) => string} */ () => {
	return `Dieser Ordner ist leer.`
};

const es_collection_items_empty_folder_message33 = /** @type {(inputs: {}) => string} */ () => {
	return `Esta carpeta está vacía.`
};

const it_collection_items_empty_folder_message33 = /** @type {(inputs: {}) => string} */ () => {
	return `Questa cartella è vuota.`
};

const ar_collection_items_empty_folder_message33 = /** @type {(inputs: {}) => string} */ () => {
	return `هذا المجلد فارغ.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const collection_items_empty_folder_message33 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.collection_items_empty_folder_message33(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("collection_items_empty_folder_message33", locale)
	if (locale === "en") return en_collection_items_empty_folder_message33(inputs)
	if (locale === "fr") return fr_collection_items_empty_folder_message33(inputs)
	if (locale === "de") return de_collection_items_empty_folder_message33(inputs)
	if (locale === "es") return es_collection_items_empty_folder_message33(inputs)
	if (locale === "it") return it_collection_items_empty_folder_message33(inputs)
	return ar_collection_items_empty_folder_message33(inputs)
};
export { collection_items_empty_folder_message33 as "COLLECTION_ITEMS_EMPTY_FOLDER_MESSAGE" }